import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { logger as E } from "../../shared-lib/index.js";
import zt from "../common/translations.js";
var lr = /*#__PURE__*/function () {
  function lr(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    _classCallCheck(this, lr);
    if (this.language = t, null != t && (t = t.toLowerCase()), null != t && null == zt[t]) {
      var _e = t.indexOf("-");
      _e > 0 && (t = t.substring(0, _e));
    }
    if (null == zt[t]) {
      var a = "Braze does not yet have a localization for language " + t + ", defaulting to English. Please contact us if you are willing and able to help us translate our SDK into this language.";
      e ? E.error(a) : E.info(a), t = "en";
    }
    this.language = t;
  }
  _createClass(lr, [{
    key: "get",
    value: function get(t) {
      return zt[this.language][t];
    }
  }, {
    key: "So",
    value: function So() {
      switch (this.language) {
        case "ar":
        case "he":
        case "fa":
          return "rtl";
        default:
          return "ltr";
      }
    }
  }]);
  return lr;
}();
export { lr as default };